import { LegalMode } from "hassibot/services_v2/common/types";
import i18next from "i18next";

import * as frContractor from "./fr/contractor.json";
import * as frMandatary from "./fr/mandatary.json";
import { i18nNamespaceEnum } from "./types";

// Only the default namespace used until the legal mode is resolved:
// `applyLegalModeNamespace` below switches to the real one at runtime. The
// broad `i18nNamespaceEnum` annotation (not the mandatary literal) is
// load-bearing for the `defaultNS` typing in src/@types/i18next.d.ts.
export const initialDefaultNamespace: i18nNamespaceEnum = i18nNamespaceEnum.mandatary;
export const frResources = { contractor: frContractor, mandatary: frMandatary };

i18next.init({
  resources: { fr: frResources },
  ns: [i18nNamespaceEnum.mandatary, i18nNamespaceEnum.contractor],
  defaultNS: initialDefaultNamespace,
  lng: "fr",
});

/**
 * Switch the i18n default namespace to match the resolved legal mode. Must run
 * before any module-scope `t()` map of the lazy app is evaluated.
 */
export const applyLegalModeNamespace = (mode: LegalMode): void => {
  i18next.setDefaultNamespace(
    mode === LegalMode.CONTRACTOR ? i18nNamespaceEnum.contractor : i18nNamespaceEnum.mandatary
  );
};
